import { clientApi } from "@/utils/api";
import { TApiRes } from "@/types/api";
import { TWeeklyStudyTime } from "@/infrastructure/adapters/study-time-tracking/study-time-tracking.types";
import { IStudyTimeTrackingService } from "@/infrastructure/services/study-time-tracking/study-time-tracking.service";

export const apiStudyTimeTrackingService: IStudyTimeTrackingService = {
  sendHeartbeat: async (req) => {
    const res = await clientApi.post<TApiRes<{ received: boolean }>>("/learning/study-time/heartbeat", req);
    return res.data.data;
  },

  getWeeklyStudyTime: async (startDate) => {
    const res = await clientApi.get<TApiRes<TWeeklyStudyTime>>("/learning/study-time/weekly", {
      params: { startDate },
    });
    return res.data.data;
  },
};
